import React from "react";

const MenuGroupHeader = ({ name }) => (
  <div className='bg-primary text-[12px] text-[#80B1CE] font-medium pt-6 pb-1 pl-6'>
    {name}
  </div>
);

export default MenuGroupHeader;